import Vue from 'vue'

// axios
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import createAuthRefreshInterceptor from 'axios-auth-refresh'

const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
})

axiosIns.interceptors.request.use(config => {
  config.headers.Accept = 'application/json'
  config.headers['Content-Type'] = 'application/json'
  config.headers.Authorization = `Bearer ${store.getters['auth/accessToken']}`
  return config
})
axiosIns.interceptors.response.use(response => response, error => {
  if (error.response.status === 401) {
    store.commit('auth/clearAuthState')
    router.push({name: 'login'}).then(()=>_)
  }
  return Promise.reject(error)
})
Vue.prototype.$http = axiosIns

export default axiosIns
